import { v4 as uuidv4 } from 'uuid';
import StorePlaceGridPluginSettings from './StorePlaceGridPluginSettings';
import StorePlaceGrid from './StorePlaceGrid';

export const StorePlaceTab = (): ITab => {
    return {
        id: uuidv4(),
        title: 'Места хранения',
        view: {
            content:    StorePlaceGridPluginSettings 
                        ? <StorePlaceGrid gridId={uuidv4()} plugin={StorePlaceGridPluginSettings} />
                        : <p> Справочник не настроен </p>
        }
    }
}

export default StorePlaceTab